// eslint-disable

import React, { useMemo, useState, useEffect } from 'react'

import MaterialTableCustom from '../../../components/MaterialTableCustom'

const MOLineageTable = ({ data }) => {
  const [tableData, setTableData] = useState(data)

  useEffect(() => {
    if (!data) return
    setTableData(Array.isArray(data) ? data : [])
  }, [data])

  const columns = useMemo(
    () => [
      { title: 'Root MO ID', field: 'rootMoId' },
      { title: 'MO ID', field: 'moId' },
      { title: 'Level', field: 'level' },
      { title: 'Part Number', field: 'partNumber' },
    ],
    [],
  )

  return (
    <MaterialTableCustom
      title={'MO Lineage Summary'}
      columns={columns}
      rowStyle={{
        fontSize: '12px',
        paddingTop: 0,
        paddingBottom: 0,
        height: 0,
      }}
      headerStyle={{
        marginTop: -5,
        paddingTop: 0,
        paddingBottom: 5,
      }}
      cellStyle={{
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: 180,
      }}
      data={tableData}
      options={{
        filtering: false,
        search: true,
        paging: false,
        actionsColumnIndex: -1,
        maxBodyHeight: '600px',
      }}
      editable={undefined}
    />
  )
}

export default MOLineageTable
